"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M1484.759 1804.811l322.334-322.334 79.736 79.963-355.313 355.312H355.346L.035 1562.44l79.85-79.963 322.22 322.334H1484.76zM884.736-.034h112.941v1167.021l355.313-355.313 79.962 79.85-491.858 491.633L449.46 891.524l79.962-79.85 355.313 355.313V-.033z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconDownload = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconDownload, _Component);
  function IconDownload() {
    (0, _classCallCheck2.default)(this, IconDownload);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconDownload).apply(this, arguments));
  }
  (0, _createClass2.default)(IconDownload, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconDownload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconDownload.displayName = "IconDownload";
  return IconDownload;
}(_react.Component);
exports.default = IconDownload;
IconDownload.glyphName = 'download';
IconDownload.variant = 'Line';
IconDownload.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);